import { z } from 'zod';
const email = z
  .string()
  .min(1, { message: 'Email is required' })
  .email({ message: 'Must be a valid email' });
const password = z
  .string()
  .min(12, { message: 'Password of 12 characters is required' });
const firstName = z.string().min(1, { message: 'First name is required' });
const lastName = z.string().min(1, { message: 'Last name is required' });
const token = z.string();
const mandatoryRecaptchaToken = z
  .string()
  .min(1, { message: 'Recaptcha token is missing or invalid' });

const recaptchaTokenSchema = (recaptchaEnabled: boolean) =>
  recaptchaEnabled ? mandatoryRecaptchaToken : token;

export {
  email,
  password,
  firstName,
  lastName,
  token,
  mandatoryRecaptchaToken,
  recaptchaTokenSchema,
};
